export default __webpack_public_path__ + "img/25fab7d01223dccb05c9940061e86f50.svg";